import { ReactElement } from 'react';

import { ControlledInputs } from '@/components';

import { useMeetingTemplateFormContext } from '../../hooks/use-meeting-template-form-context';

const MeetingCategory = (): ReactElement => {
  const form = useMeetingTemplateFormContext();
  return (
    <ControlledInputs.TextField
      ControllerProps={{
        control: form.control,
        name: 'meeting_category',
      }}
      fullWidth
      label="Category"
      placeholder="Enter category"
    />
  );
};

export default MeetingCategory;
